
export default {
  props: {
    bg: {
      type: String,
      default: ''
    }
  },
    data(){
        return{
            // isVisible:false
        }
    },
    methods:{

    }
}
